import { Search as SearchIcon } from 'lucide-react';

import { useQuery } from '@/helpers/useQuery';

import CoachRow from './CoachRow';

import {
  Table,
  TableBody,
  TableHeader,
  TableHead,
  TableRow
} from '@/components/ui/table';
import { Card } from '@/components/ui/card';
import {
  Empty,
  EmptyIcon,
  EmptyTitle,
  EmptyDescription
} from '@/components/ui/empty';

import { useCoaches } from '@/data/coach';

const CoachList = () => {
  const q = useQuery('q');
  const coaches = useCoaches({ q });

  if (coaches.data?.length === 0) {
    return (
      <Empty>
        <EmptyIcon>
          <SearchIcon />
        </EmptyIcon>
        <EmptyTitle>No Coaches Found</EmptyTitle>
        <EmptyDescription>Try adjusting your search</EmptyDescription>
      </Empty>
    );
  }

  return (
    <>
      <Card>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Name</TableHead>
              <TableHead>Email</TableHead>
              <TableHead>Activities</TableHead>
              <TableHead>Joined</TableHead>
              <TableHead />
              <TableHead />
            </TableRow>
          </TableHeader>
          <TableBody>
            {coaches.data?.map((coach) => (
              <CoachRow key={coach.id} coach={coach} />
            ))}
          </TableBody>
        </Table>
      </Card>
      <div className="text-center p-4">
        <span className="text-sm text-muted-foreground">
          Total: {coaches.data?.length}
        </span>
      </div>
    </>
  );
};

export default CoachList;
